import { render, staticRenderFns } from "./form-partial-other.vue?vue&type=template&id=1a0bbb1d"
import script from "./form-partial-other.vue?vue&type=script&lang=js"
export * from "./form-partial-other.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports